import { h, render } from 'preact';
import SimilarProducts from './similar-products';

export default (element, data) => {
  const init = () => {
    render(
      <SimilarProducts
        handle={data.handle}
        title={data.title}
        secret={data.secret}
        clientId={data.clientId}
        trackerId={data.trackerId}
        experienceId={data.experienceId}
        productId={data.productId}
        xgenKey={data.xgenKey}
      />,
      element,
    );
  };

  init();
};
